// extracted by mini-css-extract-plugin
export default {"container":"UAPRB","linkWrapper":"jPfz6","logo":"R8onm","title":"uToUc","message":"u1HvF","label":"caeoa","hidden":"cfUNZ"};